document.addEventListener("turbolinks:load", function() {

  $('.recommend_tuning_setting_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.recommend_tuning_setting_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.recommend_tuning_setting_slidedown_btn').fadeIn(0));
  });

  $('.recommend_tuning_setting_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.recommend_tuning_setting_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.recommend_tuning_setting_slideup_btn').fadeIn(0));
  });

  // #################################################################
  // チューニングの設定
  // #################################################################
  function setupChangeHandler(selectors, setting_name) {
    $(selectors).on('change', function () {
        let val = Math.abs($(this).val());

        $.ajax({
            url: '/recommend_tuning_setting/save_range',
            type: 'POST',
            data: { 
              setting_name: setting_name,
              value: val
            },
            dataType: 'json',
        }).done(function (data) {
          $(selectors).val(val);
        });
    });
  }

  setupChangeHandler('#weight_high_popularity_range, #weight_high_popularity', 'weight_high_popularity');
  setupChangeHandler('#weight_low_popularity_range, #weight_low_popularity', 'weight_low_popularity');
  setupChangeHandler('#weight_new_and_restocked_range, #weight_new_and_restocked', 'weight_new_and_restocked');
  setupChangeHandler('#weight_high_stock_range, #weight_high_stock', 'weight_high_stock');
  setupChangeHandler('#weight_low_stock_range, #weight_low_stock', 'weight_low_stock');
  setupChangeHandler('#weight_discounted_range, #weight_discounted', 'weight_discounted');
  setupChangeHandler('#weight_recommended_range, #weight_recommended', 'weight_recommended');
});